
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.bs-pain-table__item');
  items.forEach((item) => {
    const summary = item.querySelector('summary');
    summary.addEventListener('click', () => {
      items.forEach((el) => {
        if (el !== item) el.removeAttribute('open');
      });
    });
  });
});
